import React from 'react';
import { ConfigProvider } from 'antd';
import { shallowEqual, useSelector } from 'react-redux';
import useBodyClass from './helpers/useBodyClass';
import AppLocale from './configs/app-locale';
import i18n from './configs/i18next';
import useDocumentTitle from './helpers/projectTitle';
import { PROJECT_NAME } from './configs/app-global';


export default function Providers({ children }) {
  const { theme } = useSelector((state) => state.theme, shallowEqual);
  useBodyClass(`dir-${i18n.language === 'ar' ? 'rtl' : 'ltr'}`);
  const { settings } = useSelector((state) => state.globalSettings);
  useDocumentTitle(settings.title || PROJECT_NAME);

  return (
    <ConfigProvider direction={i18n.language === 'ar' ? 'rtl' : 'ltr'} locale={AppLocale[i18n.language]}>
      {children}
    </ConfigProvider>
  );
}
